module.exports = __webpack_public_path__ + "static/img/best-actress-3b-lg.ad0db7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best-actress-3b-lg.jpg
// module id = 53
// module chunks = 0